import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "complex-table-constructs"
    }}>{`Complex Table Constructs`}</h1>
    <p>{`Add additional properties to table tags to apply advanced functionalities on table.`}</p>
    <h2 {...{
      "id": "dynamically-expand-table-rows-or-columns"
    }}>{`Dynamically expand table rows or columns`}</h2>
    <p>{`Specify the cell extension property inside the table cell to indicate whether to expand table rows vertically or columns horizontally.`}</p>
    <p>{`JSON representation of the input data:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "subscriptions": [
    {
      "name": "Adobe Document API",
      "price": "99"
    },
    {
      "name": "Adobe Marketing API",
      "price": "199"
    },
    {
      "name": "Adobe Design API",
      "price": "299"
    }

  ]
}
`}</code></pre>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Repeat table rows vertically`}</strong>{` - `}<em parentName="li">{`{{subscriptions.name:`}<strong parentName="em">{`cell-extension(vertical)`}</strong>{`}}`}</em>{` tag lets the engine know that cells will be extended in vertical direction.`}</li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "16.875%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/d42f501dddf0bec227856817579b6413/5530d/vertical-extension1.webp 320w", "/document-services/docs/static/d42f501dddf0bec227856817579b6413/0c8fb/vertical-extension1.webp 640w", "/document-services/docs/static/d42f501dddf0bec227856817579b6413/94b1e/vertical-extension1.webp 1280w", "/document-services/docs/static/d42f501dddf0bec227856817579b6413/0b34d/vertical-extension1.webp 1920w", "/document-services/docs/static/d42f501dddf0bec227856817579b6413/20917/vertical-extension1.webp 2288w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/d42f501dddf0bec227856817579b6413/dd4a7/vertical-extension1.png 320w", "/document-services/docs/static/d42f501dddf0bec227856817579b6413/0f09e/vertical-extension1.png 640w", "/document-services/docs/static/d42f501dddf0bec227856817579b6413/bbbf7/vertical-extension1.png 1280w", "/document-services/docs/static/d42f501dddf0bec227856817579b6413/ac7a9/vertical-extension1.png 1920w", "/document-services/docs/static/d42f501dddf0bec227856817579b6413/6eb37/vertical-extension1.png 2288w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/d42f501dddf0bec227856817579b6413/bbbf7/vertical-extension1.png",
            "alt": "Table gets vertically extended as table rows are repeated",
            "title": "Table gets vertically extended as table rows are repeated",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Repeat table columns horizontally`}</strong>{` - `}<em parentName="li">{`{{subscriptions.name:`}<strong parentName="em">{`cell-extension(horizontal)`}</strong>{`}}`}</em>{` tag lets the engine know that cells will be extended in horizontal direction.`}</li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "15.312499999999998%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/1d2c24028dfbabf2335ceb846cb4e98d/5530d/horizontal-extension1.webp 320w", "/document-services/docs/static/1d2c24028dfbabf2335ceb846cb4e98d/0c8fb/horizontal-extension1.webp 640w", "/document-services/docs/static/1d2c24028dfbabf2335ceb846cb4e98d/94b1e/horizontal-extension1.webp 1280w", "/document-services/docs/static/1d2c24028dfbabf2335ceb846cb4e98d/0b34d/horizontal-extension1.webp 1920w", "/document-services/docs/static/1d2c24028dfbabf2335ceb846cb4e98d/c0b0b/horizontal-extension1.webp 2278w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/1d2c24028dfbabf2335ceb846cb4e98d/dd4a7/horizontal-extension1.png 320w", "/document-services/docs/static/1d2c24028dfbabf2335ceb846cb4e98d/0f09e/horizontal-extension1.png 640w", "/document-services/docs/static/1d2c24028dfbabf2335ceb846cb4e98d/bbbf7/horizontal-extension1.png 1280w", "/document-services/docs/static/1d2c24028dfbabf2335ceb846cb4e98d/ac7a9/horizontal-extension1.png 1920w", "/document-services/docs/static/1d2c24028dfbabf2335ceb846cb4e98d/b3ebc/horizontal-extension1.png 2278w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/1d2c24028dfbabf2335ceb846cb4e98d/bbbf7/horizontal-extension1.png",
            "alt": "Table gets horizontally extended as table columns are repeated",
            "title": "Table gets horizontally extended as table columns are repeated",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`Default extension is vertical. If cell-extension construct is not provided, then table will be extended in vertical direction.`}</p>
    <h2 {...{
      "id": "dynamic-table-columns"
    }}>{`Dynamic table columns`}</h2>
    <p>{`Discard a column or set of columns in a table from the final generated document as follows :`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../document-generation-api/complextableconstructs.md#discard-column-if-empty"
        }}>{`Discard column if empty`}</a>{`.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../document-generation-api/complextableconstructs.md#discard-column-if-condition-evaluates-to-true"
        }}>{`Discard column if condition evaluates to true`}</a>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "discard-column-if-empty"
    }}>{`Discard column if empty`}</h3>
    <p>{`Column in a table can be discarded if every element of an array in the input json is empty or null.`}</p>
    <p><strong parentName="p">{`How to use`}</strong>{` `}<br />{`
Add discard-if-empty construct with boolean false/true along with the template tag to activate discard if empty feature for the corresponding column.`}</p>
    <p>{`JSON representation of the input data:`}</p>
    <p><em parentName="p">{`Json 1`}</em></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "Project": [
    {
      "Name": "ABC Infra",
      "Milestone": "First Milestone",
      "DateComplete": "24/06/2021",
      "Notes": ""
    },
    {
      "Name": "ABC Infra",
      "Milestone": "Second Milestone",
      "DateComplete": "24/06/2022",
      "Notes": ""
    },
    {
      "Name": "DEF Computer Labs",
      "Milestone": "First Milestone",
      "DateComplete": "12/12/2021",
      "Notes": ""
    },
    {
      "Name": "DEF Computer Labs",
      "Milestone": "Second Milestone",
      "DateComplete": "12/12/2021",
      "Notes": ""
    }
  ]
}
`}</code></pre>
    <p><em parentName="p">{`Json2`}</em></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "Project": [
    {
      "Name": "ABC Infra",
      "Milestone": "First Milestone",
      "DateComplete": "24/06/2021"
    },
    {
      "Name": "ABC Infra",
      "Milestone": "Second Milestone",
      "DateComplete": "24/06/2022"
    },
    {
      "Name": "DEF Computer Labs",
      "Milestone": "First Milestone",
      "DateComplete": "12/12/2021"
    },
    {
      "Name": "DEF Computer Labs",
      "Milestone": "Second Milestone",
      "DateComplete": "12/12/2021"
    }
  ]
}
`}</code></pre>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "19.687500000000004%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/a88d8ee0937bdc784c496a2f039acbe5/5530d/discard_column_if_empty.webp 320w", "/document-services/docs/static/a88d8ee0937bdc784c496a2f039acbe5/0c8fb/discard_column_if_empty.webp 640w", "/document-services/docs/static/a88d8ee0937bdc784c496a2f039acbe5/94b1e/discard_column_if_empty.webp 1280w", "/document-services/docs/static/a88d8ee0937bdc784c496a2f039acbe5/2df7d/discard_column_if_empty.webp 1766w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/a88d8ee0937bdc784c496a2f039acbe5/dd4a7/discard_column_if_empty.png 320w", "/document-services/docs/static/a88d8ee0937bdc784c496a2f039acbe5/0f09e/discard_column_if_empty.png 640w", "/document-services/docs/static/a88d8ee0937bdc784c496a2f039acbe5/bbbf7/discard_column_if_empty.png 1280w", "/document-services/docs/static/a88d8ee0937bdc784c496a2f039acbe5/23a6b/discard_column_if_empty.png 1766w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/a88d8ee0937bdc784c496a2f039acbe5/bbbf7/discard_column_if_empty.png",
            "alt": "Adding discard-if-empty construct with boolean false/true along with the template tag to activate discard if empty feature for the corresponding column",
            "title": "Adding discard-if-empty construct with boolean false/true along with the template tag to activate discard if empty feature for the corresponding column",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`{{Project.Notes:`}<strong parentName="p">{`discard-if-empty(true)`}</strong>{`}} tag lets the engine discard the particular column if every element of an array in the input json is either empty or null.`}</p>
    <p><strong parentName="p">{`Note`}</strong>{`: The row above the authored row will be considered as a header row. Cell from the header row will be discarded along with discarded column.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "20.9375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/5ab461602db5fb7e0e065e3903428ef2/5530d/header_row1.webp 320w", "/document-services/docs/static/5ab461602db5fb7e0e065e3903428ef2/0c8fb/header_row1.webp 640w", "/document-services/docs/static/5ab461602db5fb7e0e065e3903428ef2/94b1e/header_row1.webp 1280w", "/document-services/docs/static/5ab461602db5fb7e0e065e3903428ef2/c9b4b/header_row1.webp 1572w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/5ab461602db5fb7e0e065e3903428ef2/dd4a7/header_row1.png 320w", "/document-services/docs/static/5ab461602db5fb7e0e065e3903428ef2/0f09e/header_row1.png 640w", "/document-services/docs/static/5ab461602db5fb7e0e065e3903428ef2/bbbf7/header_row1.png 1280w", "/document-services/docs/static/5ab461602db5fb7e0e065e3903428ef2/dc8ac/header_row1.png 1572w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/5ab461602db5fb7e0e065e3903428ef2/bbbf7/header_row1.png",
            "alt": "Header Row of Development Milestones table",
            "title": "Header Row of Development Milestones table",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "21.875%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/7c4cc8d11e9d8676e557f90645d0a4bb/5530d/header_row2.webp 320w", "/document-services/docs/static/7c4cc8d11e9d8676e557f90645d0a4bb/0c8fb/header_row2.webp 640w", "/document-services/docs/static/7c4cc8d11e9d8676e557f90645d0a4bb/94b1e/header_row2.webp 1280w", "/document-services/docs/static/7c4cc8d11e9d8676e557f90645d0a4bb/8cb6d/header_row2.webp 1576w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/7c4cc8d11e9d8676e557f90645d0a4bb/dd4a7/header_row2.png 320w", "/document-services/docs/static/7c4cc8d11e9d8676e557f90645d0a4bb/0f09e/header_row2.png 640w", "/document-services/docs/static/7c4cc8d11e9d8676e557f90645d0a4bb/bbbf7/header_row2.png 1280w", "/document-services/docs/static/7c4cc8d11e9d8676e557f90645d0a4bb/f31ea/header_row2.png 1576w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/7c4cc8d11e9d8676e557f90645d0a4bb/bbbf7/header_row2.png",
            "alt": "Header Row of Conversion tracking table",
            "title": "Header Row of Conversion tracking table",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "16.5625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/9b0626ed88ca96edaf3a2cce899b59b3/5530d/without_header_row.webp 320w", "/document-services/docs/static/9b0626ed88ca96edaf3a2cce899b59b3/0c8fb/without_header_row.webp 640w", "/document-services/docs/static/9b0626ed88ca96edaf3a2cce899b59b3/94b1e/without_header_row.webp 1280w", "/document-services/docs/static/9b0626ed88ca96edaf3a2cce899b59b3/64296/without_header_row.webp 1600w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/9b0626ed88ca96edaf3a2cce899b59b3/dd4a7/without_header_row.png 320w", "/document-services/docs/static/9b0626ed88ca96edaf3a2cce899b59b3/0f09e/without_header_row.png 640w", "/document-services/docs/static/9b0626ed88ca96edaf3a2cce899b59b3/bbbf7/without_header_row.png 1280w", "/document-services/docs/static/9b0626ed88ca96edaf3a2cce899b59b3/42cbc/without_header_row.png 1600w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/9b0626ed88ca96edaf3a2cce899b59b3/bbbf7/without_header_row.png",
            "alt": "Development Milestones table without header row",
            "title": "Development Milestones table without header row",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "discard-column-if-condition-evaluates-to-true"
    }}>{`Discard column if condition evaluates to true`}</h3>
    <p>{`Column in the table can be discarded If condition provided in the discard-if(expr(`}<strong parentName="p">{`condition`}</strong>{`)) evaluates to true. Add discard-if(expr(`}<strong parentName="p">{`condition`}</strong>{`)) construct along with the template tag to activate discard if feature for the corresponding column.`}</p>
    <p>{`JSON representation of the input data:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "Conversion": [
    {
      "Month": "July, 2021",
      "Rate": 10,
      "Method": "Payout by Cheque"
    },
    {
      "Month": "September, 2021",
      "Rate": 30,
      "Method": "Payout by Cheque"
    },
    {
      "Month": "Dec, 2021",
      "Rate": 20,
      "Method": "Payout by Cheque"
    },
    {
      "Month": "April, 2022",
      "Rate": 20,
      "Method": "Payout by Cheque"
    },
    {
      "Month": "Dec, 2022",
      "Rate": 30,
      "Method": "Payout by Cheque"
    }
  ]
}
`}</code></pre>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "20.3125%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/3bf5cc63a5dfaad7a8a1172a7e5e8586/5530d/discard_if_condition_true.webp 320w", "/document-services/docs/static/3bf5cc63a5dfaad7a8a1172a7e5e8586/0c8fb/discard_if_condition_true.webp 640w", "/document-services/docs/static/3bf5cc63a5dfaad7a8a1172a7e5e8586/94b1e/discard_if_condition_true.webp 1280w", "/document-services/docs/static/3bf5cc63a5dfaad7a8a1172a7e5e8586/27449/discard_if_condition_true.webp 1696w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/3bf5cc63a5dfaad7a8a1172a7e5e8586/dd4a7/discard_if_condition_true.png 320w", "/document-services/docs/static/3bf5cc63a5dfaad7a8a1172a7e5e8586/0f09e/discard_if_condition_true.png 640w", "/document-services/docs/static/3bf5cc63a5dfaad7a8a1172a7e5e8586/bbbf7/discard_if_condition_true.png 1280w", "/document-services/docs/static/3bf5cc63a5dfaad7a8a1172a7e5e8586/56508/discard_if_condition_true.png 1696w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/3bf5cc63a5dfaad7a8a1172a7e5e8586/bbbf7/discard_if_condition_true.png",
            "alt": "Added discard-if(expr(**condition**)) construct along with the template tag to activate discard if feature for the corresponding column",
            "title": "Added discard-if(expr(**condition**)) construct along with the template tag to activate discard if feature for the corresponding column",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`{{Conversion.Rate:`}<strong parentName="p">{`discard-if(expr($sum(Conversion.Rate)!= 100))`}</strong>{`}} tag lets the engine discard the particular column if condition provided in the `}<strong parentName="p">{`expr`}</strong>{` construct evaluates to true.`}</p>
    <h2 {...{
      "id": "dynamic-table-rows"
    }}>{`Dynamic table rows`}</h2>
    <p>{`Discard a row or set of rows in a table from the final generated document.`}</p>
    <h3 {...{
      "id": "discard-row-if-condition-evaluates-to-true"
    }}>{`Discard row if condition evaluates to true`}</h3>
    <p>{`A row in the table can be discarded only when the condition in the discard-row-if(expr(`}<strong parentName="p">{`condition`}</strong>{`),`}<strong parentName="p">{`context`}</strong>{`) evaluates to true in the provided context. Add this construct along with the template tag to discard the row based on the provided condition.`}</p>
    <p>{`For Example: {{TABLE_CONTEXT.PROPERTY:`}<strong parentName="p">{`discard-row-if(expr(PROPERTY = "TEST_VALUE"),TABLE_CONTEXT)`}</strong>{`}}`}</p>
    <p>{`JSON representation of the input data:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "Conversion": [
    {
      "Month": "July, 2021",
      "Rate": 10,
      "Method": "Payout by Cheque"
    },
    {
      "Month": "Dec, 2021",
      "Rate": 20,
      "Method": "Payout by Cheque"
    },
    {
      "Month": "Dec, 2022",
      "Rate": 40,
      "Method": "Payout by Cheque"
    },
    {
      "Month": "Dec, 2021",
      "Rate": 80,
      "Method": "Payout by Cheque"
    },
    {
      "Month": "April, 2022",
      "Rate": 100,
      "Method": "Payout by Cash"
    },
    {
      "Month": "Dec, 2022",
      "Rate": 45,
      "Method": "Payout by Cheque"
    }
  ]
}
`}</code></pre>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "20.625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/9790f15d7eada326bacf604e05335d20/5530d/discard_row_if_condition_true.webp 320w", "/document-services/docs/static/9790f15d7eada326bacf604e05335d20/0c8fb/discard_row_if_condition_true.webp 640w", "/document-services/docs/static/9790f15d7eada326bacf604e05335d20/94b1e/discard_row_if_condition_true.webp 1280w", "/document-services/docs/static/9790f15d7eada326bacf604e05335d20/0b34d/discard_row_if_condition_true.webp 1920w", "/document-services/docs/static/9790f15d7eada326bacf604e05335d20/d5269/discard_row_if_condition_true.webp 2560w", "/document-services/docs/static/9790f15d7eada326bacf604e05335d20/8abdd/discard_row_if_condition_true.webp 3514w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/9790f15d7eada326bacf604e05335d20/dd4a7/discard_row_if_condition_true.png 320w", "/document-services/docs/static/9790f15d7eada326bacf604e05335d20/0f09e/discard_row_if_condition_true.png 640w", "/document-services/docs/static/9790f15d7eada326bacf604e05335d20/bbbf7/discard_row_if_condition_true.png 1280w", "/document-services/docs/static/9790f15d7eada326bacf604e05335d20/ac7a9/discard_row_if_condition_true.png 1920w", "/document-services/docs/static/9790f15d7eada326bacf604e05335d20/c7a69/discard_row_if_condition_true.png 2560w", "/document-services/docs/static/9790f15d7eada326bacf604e05335d20/68759/discard_row_if_condition_true.png 3514w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/9790f15d7eada326bacf604e05335d20/bbbf7/discard_row_if_condition_true.png",
            "alt": "Added discard-row-if(expr(condition),context) construct along with the template tag to activate discard row if feature for the corresponding rows",
            "title": "Added discard-row-if(expr(condition),context) construct along with the template tag to activate discard row if feature for the corresponding rows",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span>{`
In a row, if multiple “discard-row-if” are used, then the row will be discarded if any one of the conditions evaluates to true.`}</p>
    <p><strong parentName="p">{`Note`}</strong>{`: The header row is also removed when all the rows are discarded thus removing the complete table.`}</p>
    <h2 {...{
      "id": "conditions-inside-tables"
    }}>{`Conditions inside tables`}</h2>
    <p>{`An additional construct `}<strong parentName="p">{`eval`}</strong>{` is introduced for conditionals inside tables, which is required while evaluating
conditions based on fields of the table currently being expanded. The expression inside `}<strong parentName="p">{`eval`}</strong>{` is an array
of objects where each entry of object serves as context to evaluate the condition in the corresponding row of table.`}</p>
    <p>{`JSON representation of the input data:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "company": [
    {
      "name": "ABC",
      "supportsX" : "TRUE"
    },
    {
      "name": "XYZ",
      "supportsX": "FALSE"
    }

  ]
}
`}</code></pre>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "22.1875%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/5181b63fd0758adaf71906a596c2fbdf/5530d/ConditionsInsideTables.webp 320w", "/document-services/docs/static/5181b63fd0758adaf71906a596c2fbdf/0c8fb/ConditionsInsideTables.webp 640w", "/document-services/docs/static/5181b63fd0758adaf71906a596c2fbdf/94b1e/ConditionsInsideTables.webp 1280w", "/document-services/docs/static/5181b63fd0758adaf71906a596c2fbdf/a713d/ConditionsInsideTables.webp 1622w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/5181b63fd0758adaf71906a596c2fbdf/dd4a7/ConditionsInsideTables.png 320w", "/document-services/docs/static/5181b63fd0758adaf71906a596c2fbdf/0f09e/ConditionsInsideTables.png 640w", "/document-services/docs/static/5181b63fd0758adaf71906a596c2fbdf/bbbf7/ConditionsInsideTables.png 1280w", "/document-services/docs/static/5181b63fd0758adaf71906a596c2fbdf/79f3a/ConditionsInsideTables.png 1622w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/5181b63fd0758adaf71906a596c2fbdf/bbbf7/ConditionsInsideTables.png",
            "alt": "Index based conditional evaluation inside table",
            "title": "Index based conditional evaluation inside table",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span>{`
In the above example, the array of objects on which the condition needs to be evaluated (`}<em parentName="p">{`company`}</em>{`) is provided in
`}<strong parentName="p">{`eval`}</strong>{`, and the expr contains the actual condition `}<inlineCode parentName="p">{`supportsX="TRUE"`}</inlineCode>{`. The condition is evaluated based on each
entry of the array and applied to the corresponding row in the output table.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      